import { render, staticRenderFns } from "./AllResourcesPage.vue?vue&type=template&id=9d83896c&scoped=true"
import script from "./AllResourcesPage.vue?vue&type=script&lang=js"
export * from "./AllResourcesPage.vue?vue&type=script&lang=js"
import style0 from "./AllResourcesPage.vue?vue&type=style&index=0&id=9d83896c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d83896c",
  null
  
)

export default component.exports